import { useState, useEffect, useCallback } from 'react'
import axios from 'axios'

export default function useGroupConversations() {
  const [groupConversations, setGroupConversations] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchGroupConversations = useCallback(async () => {
    try {
      setIsLoading(true)
      setError(null)
      const response = await axios.get('/api/group_conversations')
      setGroupConversations(response.data.data || [])
    } catch (err) {
      console.error('Error fetching group conversations:', err)
      setError(err.message)
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchGroupConversations()
  }, [fetchGroupConversations])

  const createGroupConversation = useCallback(async (payload) => {
    const response = await axios.post('/api/group_conversations', {
      group_conversation: payload
    })
    const newConversation = response.data.data
    setGroupConversations((prev) => [newConversation, ...prev])
    return newConversation
  }, [])

  const updateGroupConversation = useCallback((conversationId, updates) => {
    setGroupConversations((prev) =>
      prev.map((gc) => (gc.id === conversationId ? { ...gc, ...updates } : gc))
    )
  }, [])

  const reorderGroupConversation = useCallback((conversationId) => {
    setGroupConversations((prev) => {
      const index = prev.findIndex((gc) => gc.id?.toString() === conversationId?.toString())
      if (index > 0) {
        const updated = [...prev]
        const [conversation] = updated.splice(index, 1)
        updated.unshift(conversation)
        return updated
      }
      return prev
    })
  }, [])

  const archiveGroupConversation = useCallback(async (conversationId) => {
    await axios.post(`/api/group_conversations/${conversationId}/archive`)
    setGroupConversations((prev) => prev.filter((gc) => gc.id !== conversationId))
  }, [])

  const deleteGroupConversation = useCallback(async (conversationId) => {
    await axios.delete(`/api/group_conversations/${conversationId}`)
    setGroupConversations((prev) => prev.filter((gc) => gc.id !== conversationId))
  }, [])

  return {
    groupConversations,
    isLoading,
    error,
    fetchGroupConversations,
    createGroupConversation,
    updateGroupConversation,
    reorderGroupConversation,
    archiveGroupConversation,
    deleteGroupConversation
  }
}
